import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page70() {
  useEffect(() => {
    document.title = "Маяк — Страница 69"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page68" />
        <ForwardLink href="/page70" />
      </div>

      <p style={{ textAlign: "right" }}>69.</p>
      <p>УПОРНО. ЯРОСТНО. ЗЛОБНО.</p>
      <p>
        Они продолжают диддлинг, джигу и хлопают все быстрее и быстрее<br/>
        и быстрее...
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Танцуй! Танцуй, Уинслоу! Танцуй!
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        (поет, очень, очень, очень<br/>
        быстро)<br/>
        <i>Подходите все, ребята, кто хочет услышать<br/>
        Как мы добирались до леса в прошлом<br/>
        году,<br/>
        О, в сани мы закинули наши<br/>
        сапоги<br/>
        Наш возница указал на большую<br/>
        голубую ель<br/>
        Тимми-ран-тин-а Фалла-ду-а-да<br/>
        Гужбан и пьянство на ходу!<br/>
        Тимми-ран-тин-а Фалла-ду-а-да--</i>
      </p>
      <p>МОЛНИЯ МЕЛЬКАЕТ В ОКНЕ.</p>
      <br/>
      <p>– ПОЗЖЕ</p>
      <p>
        МОЛОДОЙ И СТАРИК танцуют медленный танец. Обняв друг друга<br/>
        за плечи. Уставшие.
      </p>
      <p>МОЛОДОЙ смотрит на него с гневом и подозрением.</p>
      <p>
        СТАРИК поет балладу. Его голос не очень-то красив или всегда<br/>
        в тональности, но баллада прекрасна, с запоминающейся мелодией --<br/>
        и его исполнение трогательно. Он глубоко погружен в него,<br/>
        переживает каждый момент.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (поет)<br/>
        <i>О, куда делись все<br/>
        вечера?<br/>
        О, где эль и виски,<br/>
        которые я пробовал?<br/>
        Ушли так же, как и потраченная впустую<br/>
        зарплата,<br/>
        В понедельник утром.<br/>
        <br/>
        Если бы птицы были джином,<br/>
        Если бы солнце было веселым<br/>
        гулякой,<br/>
        Если бы я мог отдать кому-нибудь другому<br/>
        печень,<br/>
        В понедельник утром.</i><br/>
        (ДАЛЕЕ)
      </p>
      <p style={{ textAlign: "right" }}>69.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page68" />
        <ForwardLink href="/page70" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710633460/the-lighthouse-script/b9xsco1bv57evmgudqf2.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page70;
